'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPersistedThreads = undefined;

var _reselect = require('reselect');

var _getThreads = require('./getThreads');

var _stubbedThreadId = require('../../threads/constants/stubbedThreadId');

var hasPersistedThreads = exports.hasPersistedThreads = (0, _reselect.createSelector)(_getThreads.getThreads, function (threads) {
  return threads.some(function (__value, key) {
    return Number(key) !== _stubbedThreadId.STUBBED_THREAD_ID;
  });
});